import { Cards, Container, Content } from "./styles";

import Image1 from "../../images/image1.png";
import Image2 from "../../images/image (1).png";
import Image3 from "../../images/image (2).png";
import Image4 from "../../images/image (3).png";
import Image5 from "../../images/image (4).png";
import Card from "../card";

const FamilyLaw = () => {
  const description = [
    {
      text: "Regulamentação de Pensão Alimentícia",
    },
    {
      text: "Oferecimento de Pensão Alimentícia",
    },
    {
      text: "Pedido de Pensão Alimentícia",
    },
    {
      text: "Acordo para pagamento de Pensão Alimentícia",
    },
    {
      text: "Revisão de Pensão Alimentícia",
    },
  ];

  const descriptionTwo = [
    {
      text: "Investigação de Paternidade",
    },
    {
      text: "Negatória de Paternidade",
    },
    {
      text: "Reconhecimento de Paternidade",
    },
    {
      text: "Adoção",
    },
    {
      text: "Adoção Unilateral",
    },
  ];

  const descriptionThree = [
    {
      text: "Inventário Extrajudicial",
    },
    {
      text: "Inventário Judicial",
    },
    {
      text: "Arrolamento de bens",
    },
    {
      text: "Testamento",
    },
  ];

  const descriptionFor = [
    {
      text: "Divórcio Consensual",
    },
    {
      text: "Divórcio Litigioso",
    },
    {
      text: "Divórcio Extrajudicial",
    },
    {
      text: "Pacto Antenupcial",
    },
    {
      text: "Reconhecimento de União Estável",
    },
    {
      text: "Dissolução de União Estável",
    },
    {
      text: "Contrato de União Estável",
    },
    {
      text: "Partilha de bens na União Estável",
    },
  ];

  const descriptionFive = [
    {
      text: "Regulamentação de Guarda",
    },
    {
      text: "Modificação de Guarda",
    },
    {
      text: "Acordo de Guarda e Moradia",
    },
    {
      text: "Modificação de Moradia",
    },
    {
      text: "Busca e Apreensão de Menor",
    },
    {
      text: "Autorização para viagem",
    },
    {
      text: "Regulamentação de Convivência",
    },
    {
      text: "Modificação de Convivência",
    },
    {
      text: "Descumprimento de Convivência",
    },
    {
      text: "Alienação Parental",
    },
  ];

  return (
    <Container>
      <Content>
        <h1>Direito de Família e Sucessões</h1>

        <Cards>
          <Card
            image={Image1}
            title="Pensão Alimentícia"
            description={description}
          />
          <Card
            image={Image2}
            title="Maternidade e Paternidade"
            description={descriptionTwo}
          />
          <Card
            image={Image3}
            title="Sucessão | Planejamento Sucessório"
            description={descriptionThree}
          />

          <Card
            image={Image4}
            title="Divórcio | União Estável"
            description={descriptionFor}
          />
          <Card
            image={Image5}
            title="Guarda e Moradia | Convivência (Visitas)"
            description={descriptionFive}
          />
        </Cards>
      </Content>
    </Container>
  );
};

export default FamilyLaw;
